import IMG_CERTIFIED from '../../assets/images/image_certified.png';
import './LandingCertifyContent.css';

const LandingCertifyContent = () => {
  return (
    <div className='landing-certify-container'>
      <div className='landing-certify-content'>
        <img className='landing-certify-image' alt='image_certified' src={IMG_CERTIFIED} />

        <div className='landing-certify-text'>
          <p className='landing-certify-paragraph'>
            แพลตฟอร์มที่คุณสามารถแลกเปลี่ยนยาได้อย่างมั่นใจ
            ทุกผลิตภัณฑ์ผ่านการรับรองมาตรฐานจากหน่วยงานที่เกี่ยวข้อง
          </p>
          <p className='landing-certify-paragraph'>
            เพื่อความปลอดภัยและคุณภาพที่ดีที่สุดสำหรับผู้ใช้งาน
          </p>
          <p className='landing-certify-paragraph last'>
            พร้อมทั้งระบบที่ใช้งานง่ายและทีมงานสนับสนุนที่พร้อมช่วยเหลือคุณตลอดเวลา
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingCertifyContent;
